import React from "react";
import PropTypes from "prop-types";
import Typography from "./Typography";
import { cn } from "../../utils/classNames";

const SectionTitle = React.forwardRef(
  ({ 
    className, 
    variant = "h2",
    children, 
    subtitle,
    ...props 
  }, ref) => {
    return (
      <div className={cn("space-y-2", className)} ref={ref} {...props}>
        <Typography variant={variant} className="font-semibold">
          {children}
        </Typography>
        {subtitle && (
          <Typography variant="body-small" className="text-muted-foreground">
            {subtitle}
          </Typography>
        )}
      </div>
    );
  }
);

SectionTitle.displayName = "SectionTitle";

SectionTitle.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf([
    "display",
    "h1",
    "h2", 
    "h3",
    "h4",
    "h5",
    "body-large",
    "body",
    "body-small",
    "caption",
  ]),
  children: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
};

export default SectionTitle;